import { useState, useEffect } from 'react';
import api from '../api';
import { useLang } from '../context/LangContext';
import { downloadReport } from '../reportDownload';

// Offcanvas-preview (rechts) van een bewaard rapport als PDF.
// props: reportId, filename, onClose
export default function ReportPreview({ reportId, filename, onClose }) {
  const { t } = useLang();
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let objUrl;
    setUrl(null); setError(false);
    api.get(`/api/reports/${reportId}/preview`, { responseType: 'blob' })
      .then(res => { objUrl = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' })); setUrl(objUrl); })
      .catch(() => setError(true));
    return () => { if (objUrl) URL.revokeObjectURL(objUrl); };
  }, [reportId]);

  return (
    <>
      <div className="offcanvas offcanvas-end show" tabIndex="-1"
        style={{ visibility: 'visible', width: 'min(92vw, 720px)' }}>
        <div className="offcanvas-header border-bottom">
          <h6 className="offcanvas-title text-truncate mb-0">
            <i className="bi bi-file-earmark-text me-2" />{filename}
          </h6>
          <div className="d-flex gap-2">
            <button type="button" className="btn btn-sm btn-outline-secondary"
              onClick={() => downloadReport(reportId, filename)} title={t('rep_download')}>
              <i className="bi bi-download" />
            </button>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>
        </div>
        <div className="offcanvas-body p-0 d-flex">
          {error
            ? <div className="text-danger p-3 m-auto text-center">{t('preview_failed')}</div>
            : !url
              ? <div className="m-auto text-center text-muted"><div className="spinner-border spinner-border-sm me-2" />{t('loading')}</div>
              : <iframe title="preview" src={url} style={{ width: '100%', height: '100%', border: 0 }} />}
        </div>
      </div>
      <div className="offcanvas-backdrop show" onClick={onClose} />
    </>
  );
}
